module.exports = __webpack_public_path__ + "img/recent-menu-icon.4c3756aa.svg";